import React, { Component } from 'react';
import {withRouter} from 'react-router';
import { Grid, Row, Well} from 'react-bootstrap';


class SavariaDashboard extends Component {

  render() {
    return (
      <div>
        <Grid>
            <Row>
                <Well ><h2>Savaria - Dashboard</h2></Well>
            </Row>
        </Grid>
      </div>
    );
  }
}

export default withRouter(SavariaDashboard);


// WEBPACK FOOTER //
// ./src/app/components/savariaDashboard.js